export enum FixedAssetsTabsEnum {
  FIXED = 'FIXED',
  INTANGIBLE = 'INTANGIBLE',
  CLOSED = 'CLOSED',
}
